import { ArticleType, CustomTheme } from '@nemuru-eng/js-api-client';

import {
  addContactInformationFormRefine,
  ContactInformationFormBaseSchema,
} from '@/components/modules/Application/components/ContactInformation/_shared/schemas/contactInformationForm.schema';
import { ContactInformationForm } from '@/components/modules/Application/components/ContactInformation/ContactInformationForm';
import { useContactInformationDefaultValues } from '@/components/modules/Application/components/ContactInformation/hooks/useContactInformationDefaultValues';
import { isAutoApplicationFlow } from '@/components/modules/Application/hooks/useGetApplicationSteps';
import { FormWrapper } from '@/components/shared/components/FormWrapper';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';

export const ContactInformation = () => {
  const {
    state: { cart, selectedAgent },
  } = useApplicationContext();
  const { getTextIdTranslation: t } = useTranslation();
  const { defaultValues } = useContactInformationDefaultValues();

  const isBirthDateRequired = !!isAutoApplicationFlow(selectedAgent, cart);

  const BaseSchema = ContactInformationFormBaseSchema(t, {
    isOrderReference1Required: cart?.cartArticleType() !== ArticleType.AUTOMOBILE,
    isDocumentNumberRequired: selectedAgent?.customTheme === CustomTheme.KTUIN,
    isBirthDateRequired,
  });

  return (
    <FormWrapper formSchema={() => addContactInformationFormRefine(BaseSchema, t)} defaultValues={defaultValues}>
      <ContactInformationForm showBirthDate={isBirthDateRequired} />
    </FormWrapper>
  );
};
